import { render, staticRenderFns } from "./MapillaryPlugin.vue?vue&type=template&id=9a5356b0&scoped=true"
import script from "./MapillaryPlugin.vue?vue&type=script&lang=ts"
export * from "./MapillaryPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./MapillaryPlugin.vue?vue&type=style&index=0&id=9a5356b0&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9a5356b0",
  null
  ,true
)

export default component.exports